import axios from "axios";

interface IListParams {
  pageNo?: number;
  pageSize?: number;
  completedAtStartDateTime?: string;
  completedAtEndDateTime?: string;
}

interface IAssetSearchListParams extends IListParams {
  pattern?: string;
}

export interface IReminderTypeInputDto {
  Name: string;
  Code: string;
  Description: string;
  CategoryId: number;
  SubCategoryId: number;
  IsRecurring: boolean;
  TimeTriggerRequired: boolean;
  TimeTriggerRepeatIntervalType: string;
  TimeTriggerRepeatIntervalValue: number | null;
  TimeTriggerDueSoonThresholdIntervalType: string;
  TimeTriggerDueSoonThresholdIntervalValue: number | null;
  OdometerTriggerRequired: boolean;
  OdometerTriggerRepeatIntervalKm: number | null;
  OdometerTriggerDueSoonThresholdIntervalKm: number | null;
  OdometerTriggerTimeBasedDueSoonThresholdIntervalValue: number | null;
  OdometerTriggerTimeBasedDueSoonThresholdIntervalType: string;
  OperationalHoursTriggerRequired: boolean;
  OperationalHoursTriggerRepeatIntervalHours: number | null;
  OperationalHoursTriggerDueSoonThresholdIntervalHours: number | null;
  SetNextDueBasedOn: string;

}

export interface IReminderInputDto {
  ReminderTypeId: string;
  AssetId: string;
  TimeTriggerNextDueDateUtc: string | null;
  OdometerTriggerNextDueOdometerKm: string | null;
  OperationalHoursTriggerNextDueOperationalHours: string | null;
  Notes: string | null;
}

export const getCategoryList = async (
  pageNo = 0,
  pageSize = 0
) => {
  let params: IListParams;

  params = {};

  if (pageNo !== 0) {
    params = { ...params, pageNo: pageNo };
  }

  if (pageSize !== 0) {
    params = { ...params, pageSize: pageSize };
  }

  return axios
    .get("/reminders/v1/category", {
      params: params,
    })
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};

export const getSubCategoryList = async (
  pageNo = 0,
  pageSize = 0
) => {
  let params: IListParams;

  params = {};

  if (pageNo !== 0) {
    params = { ...params, pageNo: pageNo };
  }

  if (pageSize !== 0) {
    params = { ...params, pageSize: pageSize };
  }

  return axios
    .get("/reminders/v1/subcategory", {
      params: params,
    })
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};

export const addSubCategory = async (
  Name: string
) => {

  const response = await axios
    .post("/reminders/v1/subcategory",
      {
        "Name": Name,
      });
  return response.data;
};


export const editSubCategory = async (
  Id: string,
  Name: string
) => {

  return axios
    .put("/reminders/v1/subcategory/" + Id,
      {
        "Name": Name
      })
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};

export const getReminderTypeList = async (
  pageNo = 0,
  pageSize = 0
) => {
  let params: IListParams;

  params = {};

  if (pageNo !== 0) {
    params = { ...params, pageNo: pageNo };
  }

  if (pageSize !== 0) {
    params = { ...params, pageSize: pageSize };
  }

  return axios
    .get("/reminders/v1/remindertype", {
      params: params,
    })
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};


export const getReminderType = async (ReminderTypeId: string) => {
  return axios
    .get("/reminders/v1/remindertype/" + ReminderTypeId)
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};

export const updateReminderType = async (
  ReminderTypeId: string,
  reminderType: IReminderTypeInputDto
) => {

  const response = await axios
    .put("/reminders/v1/remindertype/" + ReminderTypeId, reminderType);

  return response.data;
};

export const addReminderType = async (
  reminderType: IReminderTypeInputDto
) => {

  const response = await axios
    .post("/reminders/v1/remindertype", reminderType);

  return response.data;
};

export const getReminderList = async (
  pageNo = 0,
  pageSize = 0
) => {
  let params: IListParams;

  params = {};

  if (pageNo !== 0) {
    params = { ...params, pageNo: pageNo };
  }

  if (pageSize !== 0) {
    params = { ...params, pageSize: pageSize };
  }

  return axios
    .get("/reminders/v1/reminder", {
      params: params,
    })
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};



export const getReminderActionRequireList = async (
  pageNo = 0,
  pageSize = 0
) => {
  let params: IListParams;

  params = {};

  if (pageNo !== 0) {
    params = { ...params, pageNo: pageNo };
  }

  if (pageSize !== 0) {
    params = { ...params, pageSize: pageSize };
  }

  return axios
    .get("/reminders/v1/reminder/requirepromptaction", {
      params: params,
    })
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};



export const getReminderActionRequireCount = async () => {
  const params: IListParams = {};

  return axios
    .get("/reminders/v1/reminder/requirepromptaction/count", {
      params: params,
    })
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};




export const getReminder = async (ReminderId: string) => {
  return axios
    .get("/reminders/v1/reminder/" + ReminderId)
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};

export const addReminder = async (
  reminder: IReminderInputDto
) => {

  const response = await axios
    .post("/reminders/v1/reminder", reminder);

  return response.data;
};

export const updateReminder = async (
  ReminderId: string,
  reminder: IReminderInputDto
) => {

  const response = await axios
    .put("/reminders/v1/reminder/" + ReminderId, reminder);

  return response.data;
};


export const completeReminder = async (
  reminderId: string
) => {

  const response = await axios
    .post("/reminders/v1/reminder/" + reminderId + "/complete");
  return response.data;
};

export const getReminderHistoryListByReminderId = async (
  reminderId: string,
  pageNo = 0,
  pageSize = 0
) => {
  let params: IListParams;

  params = {};

  if (pageNo !== 0) {
    params = { ...params, pageNo: pageNo };
  }

  if (pageSize !== 0) {
    params = { ...params, pageSize: pageSize };
  }

  return axios
    .get("/reminders/v1/reminder/" + reminderId + "/history", {
      params: params,
    })
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};

export const getReminderHistoryList = async (
  startDate: string,
  endDate: string,
  pageNo = 0,
  pageSize = 0
) => {

  let params: IListParams = { completedAtStartDateTime: startDate, completedAtEndDateTime: endDate };

  if (pageNo !== 0) {
    params = { ...params, pageNo: pageNo };
  }

  if (pageSize !== 0) {
    params = { ...params, pageSize: pageSize };
  }

  return axios
    .get("/reminders/v1/reminder/history", {
      params: params,
    })
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};


export const getAssetList = async (
  pageNo = 0,
  pageSize = 0
) => {
  let params: IListParams;

  params = {};

  if (pageNo !== 0) {
    params = { ...params, pageNo: pageNo };
  }

  if (pageSize !== 0) {
    params = { ...params, pageSize: pageSize };
  }

  return axios
    .get("/reminders/v1/asset", {
      params: params,
    })
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};

export const getAssetSearchList = async (
  search = "",
  pageNo = 0,
  pageSize = 0
) => {
  let params: IAssetSearchListParams;

  params = { pattern: search };

  if (pageNo !== 0) {
    params = { ...params, pageNo: pageNo };
  }

  if (pageSize !== 0) {
    params = { ...params, pageSize: pageSize };
  }

  return axios
    .get("/reminders/v1/asset/search", {
      params: params,
    })
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};

export const updateReminderNote = async (
  reminderId: string,
  reminderNote: string
) => {

  const response = await axios
    .put("/reminders/v1/reminder/" + reminderId + "/notes", { "Notes": reminderNote });

  return response.data;
};

export const deleteReminderNote = async (
  reminderId: string
) => {

  const response = await axios
    .delete("/reminders/v1/reminder/" + reminderId + "/notes");

  return response.data;
};
